const form = document.querySelector('.preview-ticket');
const input = form.querySelector('input[name="password"]');
const error = form.querySelector('.preview-error');

form.addEventListener('submit', async (event) => {
    event.preventDefault();

    const res = await fetch(form.action, { method: 'POST', body: new URLSearchParams(new FormData(form)) });
    if (res.ok) {
        location.href = '/';
        return;
    }

    error.hidden = false;
    input.setAttribute('aria-invalid', 'true');
    input.select();

    // Bei jedem falschen Versuch nochmal schütteln
    form.classList.remove('is-invalid');
    void form.offsetWidth;
    form.classList.add('is-invalid');
});
